import { checkActionCode, confirmPasswordReset, getAuth } from 'firebase/auth'
import { useRouter } from 'next/router'
import React, { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import styled from 'styled-components'
import { media } from 'utils/media'
import { TextButton } from 'lib/Button/TextButton'
import { FormField } from 'lib/FormField'
import { GridSection } from 'lib/OldGrid'
import { Section } from 'lib/Section'
import { SubmitButton } from 'lib/SubmitButton'
import { Paragraph, ContentPageTitle } from 'lib/Text'
import { TextInput } from 'lib/TextInput'
import { Page } from 'modules/Page'
import { useAuthentication } from 'modules/auth/useAuthentication'

const Content = styled.article`
  grid-column: 4 / 12;

  ${media.tabletDown} {
    grid-column: start / end;
  }
`

const ErrorMessage = styled(Paragraph)`
  color: var(--red-80);
`

interface FormData {
  password: string
}

const ChangePasswordPage = () => {
  const { register, handleSubmit } = useForm<FormData>()
  const [errorMessage, setErrorMessage] = useState<string>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const [showSuccess, setShowSuccess] = useState<boolean>(false)
  const {
    query: { oobCode }
  } = useRouter()
  const { authenticationService } = useAuthentication()

  useEffect(() => {
    const checkCode = async () => {
      if (!oobCode) {
        return
      }

      try {
        const auth = getAuth()
        const res = await checkActionCode(auth, oobCode as string)
        // eslint-disable-next-line no-console
        console.log('res', res)
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log('err', err)
      }
    }

    checkCode()
  }, [oobCode])

  const onSubmit = async ({ password }: FormData) => {
    setLoading(true)
    setErrorMessage(null)
    try {
      const auth = getAuth()
      await confirmPasswordReset(auth, oobCode as string, password)
      setShowSuccess(true)
    } catch (err) {
      setErrorMessage(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Section fill>
      <GridSection>
        <Content>
          <ContentPageTitle>Change Password</ContentPageTitle>

          {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}

          {!showSuccess && (
            <form onSubmit={handleSubmit(onSubmit)}>
              <FormField label="New Password">
                <TextInput {...register('password')} type="password" required />
              </FormField>

              <SubmitButton loading={loading}>Change password</SubmitButton>
            </form>
          )}

          {showSuccess && (
            <Paragraph>
              Your password has been reset.{' '}
              <TextButton onClick={() => authenticationService.send({ type: 'SHOW_MODAL', mode: 'login', analyticsContext: 'change-password' })}>
                Click here to log in
              </TextButton>
            </Paragraph>
          )}
        </Content>
      </GridSection>
    </Section>
  )
}

export default ChangePasswordPage

ChangePasswordPage.getLayout = function getLayout(page: React.ReactElement) {
  return <Page meta={{ title: 'Change password', index: false }}>{page}</Page>
}
